
import { TupleTruthify } from "core/type-utils";
import { filter, OperatorFunction } from "rxjs";

export const filterAllTruthyInTuple = <T extends readonly any[]>() => filter<T>((tuple) => tuple.findIndex((part) => !part) < 0) as OperatorFunction<T, TupleTruthify<T>>

